import AppBarElement from './AppBar.element.jsx'

if (!window.customElements.get('app-bar')) {
  window.customElements.define('app-bar', AppBarElement)
}
